
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWireCross as ObiWireCrossElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-wire-cross.js';
 
 
 

 
 export const ObiWireCross = createComponent({
   react: React,
   tagName: 'obi-wire-cross',
   elementClass: ObiWireCrossElement,
   events: {
     
   }
  });
 
 